import { render, staticRenderFns } from "./sign-history.vue?vue&type=template&id=52333682&scoped=true"
import script from "./sign-history.vue?vue&type=script&lang=js"
export * from "./sign-history.vue?vue&type=script&lang=js"
import style0 from "./sign-history.vue?vue&type=style&index=0&id=52333682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52333682",
  null
  
)

export default component.exports